import React from 'react';
import { Helmet } from 'react-helmet-async';

const PageTitle = ({ title }) => {
    const baseTitle = 'Evoo Medical';
    const fullTitle = title ? `${title} | ${baseTitle}` : baseTitle;

    return (
        <Helmet>
            <title>{fullTitle}</title>
        </Helmet>
    );
};

export default PageTitle;
